import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { bool, func, node, string } from 'prop-types';

import style from './ButtonIcon.module.scss';

// todo: this whole component with it usages should be replaced with ButtonLink
function ButtonIcon({ children, className, onClick, show, path }) {
  const history = useHistory();

  const onClose = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (path) {
      history.push(path);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <button
      className={classNames(style.buttonIcon, className)}
      onClick={onClose}
      type="button"
    >
      {children}
    </button>
  );
}

export const propTypes = {
  className: string,
  onClick: func,
  show: bool,
  path: string,
};

ButtonIcon.defaultProps = {
  show: true,
};

ButtonIcon.propTypes = {
  ...propTypes,
  children: node.isRequired,
};

export default ButtonIcon;
